import { render } from "./CategoryBox.vue?vue&type=template&id=02737750&scoped=true"
import script from "./CategoryBox.vue?vue&type=script&lang=js"
export * from "./CategoryBox.vue?vue&type=script&lang=js"

import "./CategoryBox.vue?vue&type=style&index=0&id=02737750&scoped=true&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\cymcorp-site\\dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02737750"]])

export default __exports__